import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';

@Component({
  template: `
    <fl-bit class="Header">
      <fl-heading
        [size]="HeadingSize.XSMALL"
        [headingType]="HeadingType.H4"
        [flMarginBottom]="Margin.SMALL"
        i18n="My project delete modal header"
      >
        Are you sure you wish to delete this project?
      </fl-heading>
    </fl-bit>
    <fl-bit class="MainBody">

    <fl-text
      [flMarginBottom]="Margin.SMALL"
      i18n="My project delete modal body"
    >
      Deleting your project will permanently remove it from our site so that no one will be able to view it.
      All bids and attached files will be erased.
    </fl-text>
    </fl-bit>
    <fl-banner-alert *ngIf="showError"
      [type]="BannerAlertType.ERROR"
      [closeable]="false"
      i18n="My project delete modal error alert"
    >
      There was a problem deleting your project. Please try again or contact support.
    </fl-banner-alert>
    <div class="ActionContainer">
      <fl-button class="ActionButton"
        [color]="ButtonColor.DEFAULT"
        [flMarginRight]="Margin.SMALL"
        (click)="cancel()"
        i18n="My project delete modal cancel button"
      >
        Cancel
      </fl-button>
      <fl-button class="ActionButton"
        [busy]="isBusy"
        [color]="ButtonColor.SECONDARY"
        (click)="confirm()"
        i18n="My project delete modal delete button"
      >
        Delete
      </fl-button>
    </div>
  `,
  styleUrls: ['./delete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteModalComponent {
  Margin = Margin;
  BannerAlertType = BannerAlertType;
  ButtonColor = ButtonColor;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  isBusy = false;
  showError = false;

  @Input() projectId: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private modalRef: ModalRef<DeleteModalComponent>,
    private auth: Auth,
    private datastore: Datastore,
  ) {}

  confirm() {
    this.isBusy = true;
    this.datastore
      .object('projects', this.auth.getUserId(), this.projectId)
      .remove()
      .then(response => {
        if (response.status === 'success') {
          this.modalRef.close(true);
          this.isBusy = false;
        } else {
          this.isBusy = false;
          // this.error = error.message;
          // use generic error message for now since error.message is gibberish
          this.showError = true;
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  cancel() {
    this.modalRef.close(false);
  }
}
